<template>
  <v-container>
    <v-card class="pa-6 site-width" >
      <Editor />
    </v-card>
  </v-container>
</template>

<script>
import Editor from "../../components/theming/theme-editor/editor.vue";

export default {
  components: { Editor },
}
</script>